module.exports = __webpack_public_path__ + "img/check.96ad289d.svg";